import { useQuery } from "@tanstack/react-query";
import { socialService } from "@/services/socialService";
import { ConnectionsResponse } from "@/types/social";

export function useUserConnections(userId: string | null) {
  const { data, isLoading, error, refetch } = useQuery<ConnectionsResponse>({
    queryKey: ["userConnections", userId],
    queryFn: () => socialService.getUserConnections(userId!),
    enabled: !!userId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  return {
    connections: data?.connections,
    isLoading,
    error,
    refetch,
  };
}
